import { Component, OnInit, Input } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SubItem } from "src/app/core/services/business/model/sub-item";
import { Request } from "src/app/parametrage/core/model/request";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { SubItemCheckedDTO } from "src/app/core/services/business/model/subItem-checked-dto";
import { UploadInRapportComponent } from "../../modal/upload-in-rapport/upload-in-rapport.component";
import { RemplacerFichierComponent } from "../../modal/remplacer-fichier/remplacer-fichier.component";
import { RenommerFichierComponent } from "../../modal/renommer-fichier/renommer-fichier.component";
import { OfficeViewerModalComponent } from "../../modal/viewer/office-viewer-modal/office-viewer-modal.component";
import { PdfViewerModalComponent } from "../../modal/viewer/pdf-viewer-modal/pdf-viewer-modal.component";
import { ImageViewerModalComponent } from "../../modal/viewer/image-viewer-modal/image-viewer-modal.component";
import { DocViewerModalComponent } from "../../modal/viewer/doc-viewer-modal/doc-viewer-modal.component";
import { DemandeSignatureService } from "src/app/core/services/business/service/demande-signature.service";
import { DemandeSignature } from "src/app/core/services/business/model/demande-signature/demande-signature";
import { DemanderSignatureModalComponent } from "../../modal/demander-signature-modal/demander-signature-modal.component";
import { FormulaireDTO } from 'src/app/parametrage/core/model/formulaire-dto';
import { SignatureService } from 'src/app/mon-portefeuille/core/service/signature.service';
import { PdfCdnViewerComponent } from '../../modal/viewer/pdf-cdn-viewer/pdf-cdn-viewer.component';
import { ESignature } from 'src/app/core/services/business/model/e-signature/e-signature';
import { DemanderESignatureComponent } from '../../modal/demander-esignature/demander-esignature.component';
import { ESignatureService } from 'src/app/core/services/business/service/e-signature.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: "app-rapport-client",
  templateUrl: "./rapport-client.component.html",
  styleUrls: ["./rapport-client.component.scss"],
})
export class RapportClientComponent implements OnInit {
  @Input() requestId: any;
  request: Request;

  rapports: SubItemCheckedDTO[];
  demandeSignatures: DemandeSignature[];
  eSignatures: ESignature[];

  formulaireSignature: FormulaireDTO;

  progress: number = 0;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _activatedRoute: ActivatedRoute,
    private _gestionFichierService: GestionFichierService,
    private _requestService: RequestService,
    private _demandeSignatureService: DemandeSignatureService,
    private _signatureService: SignatureService,
    private _eSignatureService: ESignatureService,
  ) {}

  ngOnInit() {
    this.getRequestById(this.requestId);
    this.getRapportsClient(this.requestId);
    this.getAllDemandeSignature(this.requestId);
    this.getAllESignature(this.requestId);
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRapportsClient(requestId) {
    this._gestionFichierService.getRapportsClient(requestId, "_").subscribe(
      (data) => {
        this.rapports = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  downloadFile(subitemId: string, filename: string) {
    this._gestionFichierService.downloadFileProgress(subitemId).subscribe(
      ({ progress, blob }) => {
        this.progress = progress;
        if (blob) {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          this.progress = 0; // Reset progress after download completes
        }
      },
      (error) => {
        console.error("Download failed", error);
        this.progress = 0; // Reset progress on error
      }
    );
  }

  refresh() {
    this.getRapportsClient(this.requestId);
  }

  upload(codeDocument) {
    const modalRef = this.modalService.open(UploadInRapportComponent, {
      centered: true,
    });

    modalRef.componentInstance.requestId = this.requestId;
    modalRef.componentInstance.codeDocument = codeDocument;
    if (codeDocument != "AUTRE") {
      modalRef.componentInstance.displayname = codeDocument;
    } else {
      modalRef.componentInstance.displayname = null;
    }

    modalRef.result.then(
      (data) => {
        // on close
        this.getRapportsClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  remplacerFichier(subitemId, name, displayname) {
    const modalRef = this.modalService.open(RemplacerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.codeDocument = name.split(".")[0];
    modalRef.componentInstance.displayname = displayname;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRapportsClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  renommerFichier(subitemId) {
    const modalRef = this.modalService.open(RenommerFichierComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRapportsClient(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  deleteFile(subItemId) {
    if (confirm("Press a button!")) {
      this._gestionFichierService.delete(subItemId).subscribe(
        (data) => {
          this.getRapportsClient(this.requestId);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  signer(subItemId) {
    this._signatureService.downloadFileAndRedirectUrl(subItemId).subscribe(
      (data) => {
        this.formulaireSignature = data;
        window.open(this.formulaireSignature.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /** */

  fileViewer(subitem: SubItem): void {
    const fileTab = subitem.name.split(".");
    const fileExtension = fileTab[fileTab.length - 1];

    if (fileExtension.toLowerCase() == "pdf") {
      this.pdfViewer(subitem.id);
    } else if (
      fileExtension.toLowerCase() == "png" ||
      fileExtension.toLowerCase() == "jpeg" ||
      fileExtension.toLowerCase() == "jpg"
    ) {
      this.imageViewer(subitem.id);
    } else {
      this.officeViewer(subitem.id);
    }
  }

  officeViewer(subitemId): void {
    const modalRef = this.modalService.open(OfficeViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  imageViewer(subitemId): void {
    const modalRef = this.modalService.open(ImageViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  docViewer(subitemId): void {
    const modalRef = this.modalService.open(DocViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  pdfCDNViewer(subitemId): void {
    const modalRef = this.modalService.open(PdfCdnViewerComponent, {
      size: "lg",
      backdrop: "static",
    });

    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getAllDemandeSignature(requestId) {
    this._demandeSignatureService.findAllByRequest(requestId).subscribe(
      (data) => {
        this.demandeSignatures = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  demanderSignature(subitemId) {
    const modalRef = this.modalService.open(DemanderSignatureModalComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;
    modalRef.componentInstance.refDossierPortail = this.request.refDossierPortail;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRapportsClient(this.requestId);
        this.getAllDemandeSignature(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  
  demanderESignature(subitemId) {
    debugger;
    const modalRef = this.modalService.open(DemanderESignatureComponent, {
      centered: true,
    });
    modalRef.componentInstance.subitemId = subitemId;

    modalRef.result.then(
      (data) => {
        // on close
        this.getRapportsClient(this.requestId);
        this.getAllESignature(this.requestId);
      },
      (reason) => {
        // on dismiss
      }
    );
  }

  getAllESignature(requestId) {
    this._eSignatureService.findAllByRequest(requestId).subscribe(
      (data) => {
        this.eSignatures = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  urlSignature(documentKey,signingKey)
  {
    let lien = environment.APP_SIGNATURE_URL+"/view/"+documentKey+"?signingKey="+signingKey;
    window.open(lien);
  }

  recevoirSignatureApi(id)
  {
    this._eSignatureService.recevoirByESignatureId(id).subscribe(
      (data) => {
        this.getRapportsClient(this.requestId);
        this.getAllESignature(this.requestId);
      },
      (error) => {
        console.log(error);
      }
    );
  }

}
